import { Skeleton, Stack } from "@mui/material";

export function CommentSkeleton() {
  return (
    <Stack
      direction="row"
      spacing={1.5}
      data-testid="comment-skeleton"
      sx={{ alignItems: "flex-start", py: 1 }}
    >
      <Skeleton
        variant="circular"
        width={32}
        height={32}
        aria-hidden
        data-testid="skeleton-shape"
      />
      <Stack spacing={0.75} aria-hidden sx={{ flex: 1 }}>
        <Skeleton width="32%" data-testid="skeleton-shape" aria-hidden />
        <Skeleton width="78%" data-testid="skeleton-shape" aria-hidden />
      </Stack>
    </Stack>
  );
}
